import { useEffect, useState } from "react";

const InputField = ({ onSubmit, submitting, disabled }) => {
  const [value, setValue] = useState("");

  const handleKeyPress = (e) => {
    if (e.key === "Enter") onSubmit?.(value);
  };

  useEffect(() => {
    if (!submitting) {
      setValue("");
    }
  }, [submitting]);

  return (
    <>
      {submitting && (
        <span className="typing-indicator">
          Generating Response
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </span>
      )}
      <div className="input-container">
        <input
          type="text"
          className={`user-box ${submitting ? "shady" : ""}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyPress}
          disabled={submitting}
        />
        <button
          type="submit"
          className={`submit-btn ${submitting || disabled ? "shady" : ""}`}
          disabled={submitting || disabled}
          onClick={() => {
            onSubmit?.(value);
          }}
        >
          <i
            className={`bi bi-arrow-up arrow`}
          ></i>
        </button>
      </div>
    </>
  );
};

export default InputField;
